import { render, staticRenderFns } from "./all.vue?vue&type=template&id=2c96de0b&scoped=true"
import script from "./all.vue?vue&type=script&lang=js"
export * from "./all.vue?vue&type=script&lang=js"
import style0 from "./all.vue?vue&type=style&index=0&id=2c96de0b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c96de0b",
  null
  
)

export default component.exports